/**
 * Initializes slick slider for product teasers.
 */
window.coma = window.coma || {};

window.coma.teaser = (function($, undefined) {
  var productSliders = $('.product-teaser-slide');

  // PRIVATE FUNCTIONS
  var _private = {

    init: function() {


      $(document).on('mediaqueries-changed', function (e) {
        // the new mediaquery (xs, sm, md, lg) is stored in e.message
        // _private.removePageOverflowOnDesktop(e.message);
        _private.checkProductTeaserSlides(e.message);
        // _private.removePageOverflowOnDesktop(e.message);
      });


      this.productTeaserInit(window.coma.mediaqueries.getDevice());

    },



    productTeaserInit: function(mediaquery) {
      productSliders.each(function (){
        let $this = $(this);

        let id = $this.attr('id');
        const slickSettings = {
          slide: 'div',
          nextArrow: '#'+id+' .slick-next',
          prevArrow: '#'+id+' .slick-prev',
          appendDots: '#'+id+' .product-teaser__nav',
          infinite: false,
          slidesToShow: 3,
          slidesToScroll: 1,
          //variableWidth: true,
          dots: true,
          responsive: [
            {
              // tablet
              arrows: false,
              breakpoint: 1210,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              },
            },
            {
              // mobile
              arrows: false,
              breakpoint: 610,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ],
        }

        if(mediaquery == 'xs') {
          if($this.find('.product-teaser__item').length > 3) {
            $this.not('.slick-initialized').slick(slickSettings);
            $this.find('.slick-slide').removeAttr('aria-describedby');
          } else {
            if($this.hasClass('slick-slider')) {
              setTimeout(() => {
                $this.slick('unslick');
              }, 500)
            }
          }
        } else {
          $this.not('.slick-initialized').slick(slickSettings);
          $this.find('.slick-slide').removeAttr('aria-describedby');
      }
      })
    },

    checkProductTeaserSlides: function(mediaquery) {
      this.productTeaserInit(mediaquery);
    },



  }

  // CALL INIT
  $(document).ready(function() {
    _private.init();
  });

}(jQuery));
